import React from 'react';
import { MessageCircle, X } from 'lucide-react';

import { useChat } from '../../context/ChatContext';
import ChatPanel from './ChatPanel';

// Floating launcher + panel (chat_bot.md §3.3). Mounted once, gated on a
// logged-in user (chat_bot.md §3.4, §4 — no guest mode) — see Layout.js.
export default function ChatWidget() {
  const { isOpen, toggleWidget } = useChat();

  return (
    <>
      <button
        type="button"
        className="ss-chat-launcher"
        onClick={toggleWidget}
        aria-label={isOpen ? 'Close chat' : 'Open chat'}
        aria-expanded={isOpen}
      >
        {isOpen ? <X size={24} aria-hidden="true" /> : <MessageCircle size={24} aria-hidden="true" />}
      </button>
      <ChatPanel />
    </>
  );
}
